import { createFileRoute } from '@tanstack/react-router';
import { ReportIssuePage } from '../../pages/report-issue';

export const Route = createFileRoute('/_app/report-issue')({
	component: ReportIssuePage,
});
